export const baseRoyaltyStatementObject = () => {
  return {
    id: "",
    value: "",
    sentDate: "",
  }
}
